module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"manual":"取扱説明書","identifiable_insect":"同定可能虫種"},"en":{"manual":"Manual","identifiable_insect":"Identifiable insect species"}}')
  delete Component.options._Ctor
}
